<template lang="pug">
p.help-block(v-if="hasError") {{ messageText }}
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ErrorHelpBlock',
  props: { message: { type: String || Boolean, default: '' } },
  computed: {
    hasError(): boolean {
      return this.messageText && String(this.messageText).length > 0;
    },
    messageText(): string {
      return this.message && (typeof this.message === 'string') ? this.message.trim() : '';
    },
  },
});
</script>

<style scoped>

</style>
